import { render } from "./RegisterTicket.vue?vue&type=template&id=f94590d4&scoped=true"
import script from "./RegisterTicket.vue?vue&type=script&lang=js"
export * from "./RegisterTicket.vue?vue&type=script&lang=js"

import "./RegisterTicket.vue?vue&type=style&index=0&id=f94590d4&scoped=true&lang=css"

import exportComponent from "/Users/administrador/Documents/RepositoriosLMX/app-tent-register/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94590d4"]])

export default __exports__